var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-card-base',[_c('div',{staticClass:"page-admin-estates-item-legal-block"},[(_vm.title)?_c('h2',{staticClass:"page-admin-estates-item-legal-block__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }